module.exports = __webpack_public_path__ + "img/Alex_couch_arm_table.2cde532b.png";